export default __webpack_public_path__ + "static/media/volume-mid.59a16253.svg";